import { toast } from "react-hot-toast";
import {AiFillDelete} from "react-icons/ai";
import { useDispatch } from "react-redux";
import { remove } from "../redux/Slices/CartSlice";



const CartItem = ({item, itemIndex}) => {
  const dispatch = useDispatch();

  const removeFromCart = () => {
    dispatch(remove(item.id));
    toast.error("Item removed");
  }

  return (
    <div className="flex items-center p-2 md:p-5 justify-between mt-2 mb-2 md:mx-5 border-b-2 border-gray-800 last:border-b-0">
      <div className="flex flex-col md:flex-row p-0 md:p-3 gap-5 items-center">
        <div className="w-[30%]">
         <img src={item.image} className="object-cover" alt=""/>
        </div>
        <div className="md:ml-10 self-start space-y-5 w-[100%] md:w-[70%]">
            <h1 className="text-xl text-slate-700 font-semibold">{item.title}</h1>
            <h1 className="text-base text-slate-700 font-medium">{item.description.split(" ").slice(0,15).join(" ") + "..." }</h1>
          <div className="flex items-center justify-between">
              <p className="font-bold text-lg text-green-600">${item.price} </p>
              <div className="bg-red-200 hover:bg-red-400 transition-transform duration-300 cursor-pointer rounded-full p-3 mr-3 group">
                <AiFillDelete className="text-red-800 group-hover:text-white text-2xl" onClick={removeFromCart} />
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
